@if (loading) {
  <p>Cargando datos...</p>
} @else if (error) {
  <p>{{ error }}</p>
} @else {

  <!-- 🔹 Filtro de estudiantes con Angular Material -->
  <div class="filtros">
    <mat-form-field appearance="outline" class="student-filter">
      <mat-label>Estudiante</mat-label>
      <mat-select
        [value]="estudianteSeleccionado"
        (valueChange)="onChangeEstudiante($event)">
        @for (est of estudiantes; track est) {
          <mat-option [value]="est">
            {{ est }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (vm?.graficas?.length) {
    <div class="chart-wrapper">
      @for (grafica of vm.graficas; track $index) {
        <google-chart
          class="full-chart"
          [title]="grafica.title"
          [type]="grafica.type"
          [data]="grafica.data"
          [columns]="grafica.columns"
          [options]="grafica.options"
          [dynamicResize]="true">
        </google-chart>
      }
    </div>
  } @else {
    <p>No hay datos para mostrar.</p>
  }
}
